import "./App.css";
import { useState } from "react";
import { UserDataContext } from "./components/UserDataContext";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Offer from "./pages/Offer";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import NoPermission from "./pages/NoPermission";
import Files from "./pages/Files";

export const API_URL = "https://tomaszfotograf.pl/api";
export const marginBottom = "10px";
export const marginTop = "20px";

function App() {
  const baseUrl = process.env.REACT_APP_BASE_URL || "/";
  const [hideFooter, setHideFooter] = useState(false);
  const hideFooterOn = ["/login", "/footer"];
  return (
    <>
      <BrowserRouter basename={baseUrl}>
        <UserDataContext.Provider
          value={{ userData: null, setUserData: () => {} }}
        >
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/offer" element={<Offer />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/nopermission" element={<NoPermission />} />
            <Route
              path="/filesgallery"
              element={<Files hideFooter={setHideFooter} />}
            />
            <Route
              path="/login"
              element={<Login hideFooter={setHideFooter} />}
            />
          </Routes>
        </UserDataContext.Provider>
      </BrowserRouter>
      {!hideFooter && <Footer />}
    </>
  );
}

export default App;
